import React from 'react';
import styled from 'styled-components';
import {isMobileOnly} from 'react-device-detect';


const EsReqRefundBlock = styled.div`
  ${isMobileOnly&&`
  td {
    position:unset;
    &:first-of-type {width:30vw;text-align:center;font-size:0.8em;word-break: keep-all;}
  }`};

`;

const EsReqRefund = ({ detailInfo }) => {



    if (detailInfo === null || detailInfo === undefined) {
        return <EsReqRefundBlock />
    }


    return (
        <EsReqRefundBlock>
            {isMobileOnly?
              <div className="default-table">
                  {/*<h3 className="dt-title">*/}
                  {/*    반품 / 교환 / AS*/}
                  {/*    /!* <!-- CMS 에서 체크시 출력 되는 문구입니다. --> *!/*/}
                  {/*</h3>*/}
                  {/*<div className="ess_text"*/}
                  {/*     style={{ display: detailInfo.masterinfo.is_claim_notice ? 'block' : 'none' }}>*/}
                  {/*    * 자세한 반품/교환/AS 정보는 상품 상세에서 확인해주세요.</div>*/}

                  {/*<table className="margin_b-30">*/}
                  {/*    <tbody>*/}
                  {/*    <tr>*/}
                  {/*        <td className="gray">반품 배송비</td>*/}
                  {/*        <td>*/}
                  {/*            <span className="font-mont"> 상품 상세 참조 </span>*/}
                  {/*        </td>*/}
                  {/*    </tr>*/}
                  {/*    <tr>*/}
                  {/*        <td className="gray">보내실 곳</td>*/}
                  {/*        <td>{detailInfo.brandinfo.rtrn_zip} )*/}
                  {/*            {detailInfo.brandinfo.rtrn_addr1} , {detailInfo.brandinfo.rtrn_addr2}*/}
                  {/*        </td>*/}
                  {/*    </tr>*/}
                  {/*    <tr>*/}
                  {/*        <td className="gray border_bottom">교환 배송비</td>*/}
                  {/*        <td className="border_bottom">*/}
                  {/*            /!* <span className="font-mont">*/}
                  {/*                  {detailInfo.brandinfo.exch_dlvry_fee === null ? '' :*/}
                  {/*                      Number(detailInfo.brandinfo.exch_dlvry_fee.toFixed(1)).toLocaleString()}*/}
                  {/*              </span> *!/*/}
                  {/*            <span className="font-mont"> 상품 상세 참조 </span>*/}
                  {/*        </td>*/}
                  {/*    </tr>*/}
                  {/*    <tr>*/}
                  {/*        <td className="gray border_bottom"></td>*/}
                  {/*        <td className="border_bottom"></td>*/}
                  {/*    </tr>*/}
                  {/*    </tbody>*/}
                  {/*</table>*/}

                  <div className="refund-box">
                      <h4>
                          * 반품/교환 사유로 요청 가능 기간
                      </h4>
                      <div style={{ marginTop: '15px', marginBottom: '15px', fontSize: '14px', color: '#999' }}>
                          반품 시 먼저 판매자와 연락하셔서 반품사유, 택배사, 배송비, 반품지 주소 등을 협의하신 후 반품상품을 발송해 주시기 바랍니다.
                      </div>
                      <ol>
                          <li>
                              1. 구매자 단순 변심은 상품 수령 후 7일 이내 <span style={{ color: '#cecece', fontsize: '14px' }}>(구매자 반품배송비 부담)</span>
                          </li>
                          <li>
                              2. 표시/광고와 상이, 상품하자의 경우 상품 수령 후 3개월 이내 혹은 표시/광고와 다른 사실을 안 날로부터 30일 이내. <br />
                              &nbsp;&nbsp;둘 중 하나 경과 시 반품/교환 불가
                              <span style={{ color: '#cecece', fontsize: '14px' }}>(판매자 반품배송비 부담)</span>
                          </li>
                      </ol>

                      <h4>
                          * 반품/교환 불가능한 사유<br></br>

                      </h4>
                      <div style={{ marginTop: '15px', marginBottom: '15px', fontSize: '14px', color: '#999' }}>
                          아래와 같은 경우 반품/교환이 불가능합니다.
                      </div>
                      <ol>
                          <li>1. 반품요청기간이 지난 경우</li>
                          <li>2. 구매자의 책임 있는 사유로 상품 등이 멸실 또는 훼손된 경우
                              <span style={{ color: '#cecece ', fontsize: '14px' }}>(단, 상품의 내용을 확인하기 위하여 포장 등을 훼손한 경우는 제외)</span>
                          </li>
                          <li>3. 포장을 개봉하였으나 포장이 훼손되어 상품가치가 현저히 상실된 경우
                              <span style={{ color: '#cecece', fontsize: '14px' }}>(예: 식품, 화장품)</span>
                          </li>
                          <li>4. 구매자의 사용 또는 일부 소비에 의하여 상품의 가치가 현저히 감소한 경우
                              <span style={{ color: '#cecece', fontsize: '14px' }}>(라벨이 떨어진 의류 또는 태그가 떨어진 명품관 상품인 경우)</span>
                          </li>
                          <li>5. 시간의 경과에 의하여 재판매가 곤란할 정도로 상품 등의 가치가 현저히 감소한 경우
                              <span style={{ color: '#cecece', fontsize: '14px' }}> (예: 식품, 화장품)</span>
                          </li>
                          <li>6. 고객주문 확인 후 상품제작에 들어가는 주문제작상품</li>
                          <li>7. 복제가 가능한 상품 등의 포장을 훼손한 경우
                              <span style={{ color: '#cecece', fontsize: '14px' }}>(CD/DVD/GAME/도서의 경우 포장 개봉 시)</span>
                          </li>
                      </ol>
                  </div>
                  {/* <div className="as_info">
                    <p className="margin_b-20 fontsize-15">
                        * 반품/교환 사유로 요청 가능 기간
                       <br />
                        <span className="info_sub fontsize-14">
                            &nbsp;&nbsp; 반품 시 먼저 판매자와 연락하셔서 반품사유, 택배사, 배송비, 반품지 주소 등을 협의하신 후 반품상품을 발송해 주시기 바랍니다.
                                    </span>
                    </p>
                    <ul className="as_list">
                        <li>
                            <span className="font-mont">1. </span>
                                        구매자 단순 변심은 상품 수령 후 7일 이내 (구매자 반품배송비 부담)
                                    </li>
                        <li>
                            <span className="font-mont">2. </span>
                                        표시/광고와 상이, 상품하자의 경우 상품 수령 후 3개월 이내 혹은 표시/광고와 다른 사실을 안 날로부터 30일 이내. 둘 중 하나 경과 시 반품/교환
                                        불가 (판매자 반품배송비 부담)
                                    </li>
                    </ul>
                </div> */}
              </div>
              :
              <div className="default-table">
                  {/*<h3 className="dt-title clearfix">*/}
                  {/*    반품 / 교환 / AS*/}
                  {/*    /!* <!-- CMS 에서 체크시 출력 되는 문구입니다. --> *!/*/}
                  {/*    <span className="ess_text f-right"*/}
                  {/*          style={{ display: detailInfo.masterinfo.is_claim_notice ? 'block' : 'none' }}>*/}
                  {/*      * 자세한 반품/교환/AS 정보는 상품 상세에서 확인해주세요.</span>*/}
                  {/*</h3>*/}

                  {/*<table className="margin_b-30">*/}
                  {/*    <colgroup>*/}
                  {/*        <col width="180px;" />*/}
                  {/*        <col width="410px;" />*/}
                  {/*        <col width="180px;" />*/}
                  {/*        <col width="410px;" />*/}
                  {/*    </colgroup>*/}

                  {/*    <tbody>*/}
                  {/*    <tr>*/}
                  {/*        <td className="gray">반품 배송비</td>*/}
                  {/*        <td>*/}
                  {/*            /!* <span className="font-mont">*/}
                  {/*              {detailInfo.masterinfo.rtrn_dlvry_fee === null ? '' :*/}
                  {/*                  Number(detailInfo.brandinfo.rtrn_dlvry_fee.toFixed(1)).toLocaleString()}*/}
                  {/*              </span> *!/*/}
                  {/*            <span className="font-mont"> 상품 상세 참조 </span>*/}
                  {/*        </td>*/}
                  {/*        <td className="gray">보내실 곳</td>*/}
                  {/*        <td>{detailInfo.brandinfo.rtrn_zip} )*/}
                  {/*            {detailInfo.brandinfo.rtrn_addr1} , {detailInfo.brandinfo.rtrn_addr2}*/}
                  {/*        </td>*/}
                  {/*    </tr>*/}
                  {/*    <tr>*/}
                  {/*        <td className="gray border_bottom">교환 배송비</td>*/}
                  {/*        <td className="border_bottom">*/}
                  {/*            /!* <span className="font-mont">*/}
                  {/*                  {detailInfo.brandinfo.exch_dlvry_fee === null ? '' :*/}
                  {/*                      Number(detailInfo.brandinfo.exch_dlvry_fee.toFixed(1)).toLocaleString()}*/}
                  {/*              </span> *!/*/}
                  {/*            <span className="font-mont"> 상품 상세 참조 </span>*/}
                  {/*        </td>*/}
                  {/*        <td className="gray border_bottom"></td>*/}
                  {/*        <td className="border_bottom"></td>*/}
                  {/*    </tr>*/}
                  {/*    </tbody>*/}
                  {/*</table>*/}

                  <div className="refund-box">
                      <h4>
                          * 반품/교환 사유로 요청 가능 기간
                      </h4>
                      <div style={{ marginTop: '15px', marginBottom: '15px', fontSize: '14px', color: '#999' }}>
                          반품 시 먼저 판매자와 연락하셔서 반품사유, 택배사, 배송비, 반품지 주소 등을 협의하신 후 반품상품을 발송해 주시기 바랍니다.
                      </div>
                      <ol>
                          <li>
                              1. 구매자 단순 변심은 상품 수령 후 7일 이내 <span style={{ color: '#cecece', fontsize: '14px' }}>(구매자 반품배송비 부담)</span>
                          </li>
                          <li>
                              2. 표시/광고와 상이, 상품하자의 경우 상품 수령 후 3개월 이내 혹은 표시/광고와 다른 사실을 안 날로부터 30일 이내. <br />
                              &nbsp;&nbsp;둘 중 하나 경과 시 반품/교환 불가
                              <span style={{ color: '#cecece', fontsize: '14px' }}>(판매자 반품배송비 부담)</span>
                          </li>
                      </ol>

                      <h4>
                          * 반품/교환 불가능한 사유<br></br>

                      </h4>
                      <div style={{ marginTop: '15px', marginBottom: '15px', fontSize: '14px', color: '#999' }}>
                          아래와 같은 경우 반품/교환이 불가능합니다.
                      </div>
                      <ol>
                          <li>1. 반품요청기간이 지난 경우</li>
                          <li>2. 구매자의 책임 있는 사유로 상품 등이 멸실 또는 훼손된 경우
                              <span style={{ color: '#cecece ', fontsize: '14px' }}>(단, 상품의 내용을 확인하기 위하여 포장 등을 훼손한 경우는 제외)</span>
                          </li>
                          <li>3. 포장을 개봉하였으나 포장이 훼손되어 상품가치가 현저히 상실된 경우
                              <span style={{ color: '#cecece', fontsize: '14px' }}>(예: 식품, 화장품)</span>
                          </li>
                          <li>4. 구매자의 사용 또는 일부 소비에 의하여 상품의 가치가 현저히 감소한 경우
                              <span style={{ color: '#cecece', fontsize: '14px' }}>(라벨이 떨어진 의류 또는 태그가 떨어진 명품관 상품인 경우)</span>
                          </li>
                          <li>5. 시간의 경과에 의하여 재판매가 곤란할 정도로 상품 등의 가치가 현저히 감소한 경우
                              <span style={{ color: '#cecece', fontsize: '14px' }}> (예: 식품, 화장품)</span>
                          </li>
                          <li>6. 고객주문 확인 후 상품제작에 들어가는 주문제작상품</li>
                          <li>7. 복제가 가능한 상품 등의 포장을 훼손한 경우
                              <span style={{ color: '#cecece', fontsize: '14px' }}>(CD/DVD/GAME/도서의 경우 포장 개봉 시)</span>
                          </li>
                      </ol>
                  </div>
                  {/* <div className="as_info">
                    <p className="margin_b-20 fontsize-15">
                        * 반품/교환 사유로 요청 가능 기간
                       <br />
                        <span className="info_sub fontsize-14">
                            &nbsp;&nbsp; 반품 시 먼저 판매자와 연락하셔서 반품사유, 택배사, 배송비, 반품지 주소 등을 협의하신 후 반품상품을 발송해 주시기 바랍니다.
                                    </span>
                    </p>
                    <ul className="as_list">
                        <li>
                            <span className="font-mont">1. </span>
                                        구매자 단순 변심은 상품 수령 후 7일 이내 (구매자 반품배송비 부담)
                                    </li>
                        <li>
                            <span className="font-mont">2. </span>
                                        표시/광고와 상이, 상품하자의 경우 상품 수령 후 3개월 이내 혹은 표시/광고와 다른 사실을 안 날로부터 30일 이내. 둘 중 하나 경과 시 반품/교환
                                        불가 (판매자 반품배송비 부담)
                                    </li>
                    </ul>
                </div> */}
              </div>

            }
        </EsReqRefundBlock>
    );
};

export default EsReqRefund;
